// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основной блок хэдера - на всю ширину экрана */
.header {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 77px;
  background: #4e3f3a;
  box-sizing: border-box;
}

.header__inner {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  box-sizing: border-box;
}

/* Логотип: 113×62, по макету left 26, top 5 */
.header__logo {
  flex-shrink: 0;
  width: 113px;
  height: 62px;
  display: block;
  text-decoration: none;
}

.header__logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Телефон: Roboto 18px, underline, #FFFFFF */
.header__phone {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  text-decoration-line: underline;
  color: #ffffff;
  white-space: nowrap;
}

.header__phone:hover {
  color: #ffffff;
  opacity: 0.9;
}

/* Слоган: Neucha 48px, #FC761F - по центру */
.header__slogan {
  flex: 1;
  margin: 0;
  padding: 0 16px;
  font-family: 'Neucha', cursive;
  font-style: normal;
  font-weight: 400;
  font-size: 48px;
  line-height: 53px;
  color: #fc761f;
  text-align: center;
  min-width: 0;
}

/* Блок с иконкой времени и часы работы */
.header__hours-block {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Иконка времени: 24.59×24.59 */
.header__time-icon {
  width: 24.59px;
  height: 24.59px;
  display: block;
}

/* Время работы: Roboto 18px, #FFFFFF */
.header__hours {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  color: #ffffff;
  white-space: nowrap;
}

.header__auth {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.header__user {
  width: 46.78px;
  height: 46.77px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.header__user:hover {
  opacity: 0.9;
}

.header__user:focus-visible {
  outline: 2px solid #fc761f;
  outline-offset: 2px;
}

.header__user img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.header__logout {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #ffffff;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.header__logout:hover {
  opacity: 0.9;
}

/* Адаптив: на узких экранах уменьшаем слоган и даём перенос */
@media (max-width: 1200px) {
  .header__slogan {
    font-size: 36px;
    line-height: 1.2;
  }
}

@media (max-width: 900px) {
  .header__inner {
    gap: 14px;
  }

  .header__phone,
  .header__hours {
    font-size: 16px;
  }

  .header__slogan {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .header {
    height: auto;
    min-height: 77px;
    padding: 8px 0;
  }

  .header__inner {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 6px 10px;
  }

  .header__logo {
    grid-column: 1;
    grid-row: 1;
    width: 80px;
    height: 44px;
  }

  .header__slogan {
    grid-column: 1 / -1;
    grid-row: 2;
    width: auto;
    font-size: 24px;
    padding: 0 8px;
    line-height: 1.1;
    text-wrap: balance;
  }

  .header__phone {
    display: none;
  }

  .header__hours-block {
    grid-column: 2;
    grid-row: 1;
    justify-self: start;
    gap: 6px;
  }

  .header__auth {
    grid-column: 3;
    grid-row: 1;
    justify-self: end;
    gap: 8px;
  }

  .header__user {
    width: 40px;
    height: 40px;
  }

  .header__hours {
    font-size: 14px;
  }

  .header__time-icon {
    width: 18px;
    height: 18px;
  }
}

@media (max-width: 430px) {
  .header__inner {
    padding: 0 12px;
    gap: 6px;
  }

  .header__logo {
    width: 64px;
    height: 36px;
  }

  .header__slogan {
    font-size: 20px;
    padding: 0;
  }

  .header__hours {
    font-size: 12px;
  }

  .header__user {
    width: 34px;
    height: 34px;
  }

  .header__logout {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,OAAO;EACP,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Основной блок хэдера - на всю ширину экрана */\n.header {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 77px;\n  background: #4e3f3a;\n  box-sizing: border-box;\n}\n\n.header__inner {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 26px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  box-sizing: border-box;\n}\n\n/* Логотип: 113×62, по макету left 26, top 5 */\n.header__logo {\n  flex-shrink: 0;\n  width: 113px;\n  height: 62px;\n  display: block;\n  text-decoration: none;\n}\n\n.header__logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* Телефон: Roboto 18px, underline, #FFFFFF */\n.header__phone {\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21px;\n  text-decoration-line: underline;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.header__phone:hover {\n  color: #ffffff;\n  opacity: 0.9;\n}\n\n/* Слоган: Neucha 48px, #FC761F - по центру */\n.header__slogan {\n  flex: 1;\n  margin: 0;\n  padding: 0 16px;\n  font-family: 'Neucha', cursive;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 48px;\n  line-height: 53px;\n  color: #fc761f;\n  text-align: center;\n  min-width: 0;\n}\n\n/* Блок с иконкой времени и часы работы */\n.header__hours-block {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n/* Иконка времени: 24.59×24.59 */\n.header__time-icon {\n  width: 24.59px;\n  height: 24.59px;\n  display: block;\n}\n\n/* Время работы: Roboto 18px, #FFFFFF */\n.header__hours {\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 21px;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.header__auth {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.header__user {\n  width: 46.78px;\n  height: 46.77px;\n  padding: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n}\n\n.header__user:hover {\n  opacity: 0.9;\n}\n\n.header__user:focus-visible {\n  outline: 2px solid #fc761f;\n  outline-offset: 2px;\n}\n\n.header__user img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.header__logout {\n  font-family: 'Roboto', sans-serif;\n  font-size: 14px;\n  color: #ffffff;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n}\n\n.header__logout:hover {\n  opacity: 0.9;\n}\n\n/* Адаптив: на узких экранах уменьшаем слоган и даём перенос */\n@media (max-width: 1200px) {\n  .header__slogan {\n    font-size: 36px;\n    line-height: 1.2;\n  }\n}\n\n@media (max-width: 900px) {\n  .header__inner {\n    gap: 14px;\n  }\n\n  .header__phone,\n  .header__hours {\n    font-size: 16px;\n  }\n\n  .header__slogan {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 768px) {\n  .header {\n    height: auto;\n    min-height: 77px;\n    padding: 8px 0;\n  }\n\n  .header__inner {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 6px 10px;\n  }\n\n  .header__logo {\n    grid-column: 1;\n    grid-row: 1;\n    width: 80px;\n    height: 44px;\n  }\n\n  .header__slogan {\n    grid-column: 1 / -1;\n    grid-row: 2;\n    width: auto;\n    font-size: 24px;\n    padding: 0 8px;\n    line-height: 1.1;\n    text-wrap: balance;\n  }\n\n  .header__phone {\n    display: none;\n  }\n\n  .header__hours-block {\n    grid-column: 2;\n    grid-row: 1;\n    justify-self: start;\n    gap: 6px;\n  }\n\n  .header__auth {\n    grid-column: 3;\n    grid-row: 1;\n    justify-self: end;\n    gap: 8px;\n  }\n\n  .header__user {\n    width: 40px;\n    height: 40px;\n  }\n\n  .header__hours {\n    font-size: 14px;\n  }\n\n  .header__time-icon {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n@media (max-width: 430px) {\n  .header__inner {\n    padding: 0 12px;\n    gap: 6px;\n  }\n\n  .header__logo {\n    width: 64px;\n    height: 36px;\n  }\n\n  .header__slogan {\n    font-size: 20px;\n    padding: 0;\n  }\n\n  .header__hours {\n    font-size: 12px;\n  }\n\n  .header__user {\n    width: 34px;\n    height: 34px;\n  }\n\n  .header__logout {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
